import Vue from 'vue';
import i18n from '@/i18n';
import store from './store';
import { DateTime } from 'luxon';
import { localize, resolveLocale } from '@/utils/i18n-helpers';

Vue.filter('localize', (element: LocaleElement, field: string) => {
	const restaurant: Restaurant = store.getters['restaurant/getRestaurant'];
	return localize(element, field, i18n.locale, restaurant.locales);
});

Vue.filter('formatDate', (value: string, format: string = 'dd/MM/yyyy') => {
	if (!value) {
		return '';
	}
	const locale = resolveLocale(i18n.locale);

	return DateTime.fromISO(value).setLocale(locale).toFormat(format);
});